import { useEffect, useState } from "react";
import Icon from "~/components/ui/Icon";

export interface Props {
  content?: string;
}

function BackToTop({ content }: Props) {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    const scrollPosition = globalThis.scrollY;
    setIsVisible(scrollPosition > 2090);
  };

  useEffect(() => {
    globalThis.addEventListener("scroll", handleScroll);
    return () => {
      globalThis.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {isVisible && (
        <div className="fixed bottom-6 right-3 z-40 rounded-full backToTop">
          <a
            href="#top"
            className="btn bg-[#FFFFFF] rounded-full w-12 px-3 hover:bg-[#FFFFFF] border-none hover:border-none"
          >
            {content}
            <Icon id="ChevronUp" width={20} height={24} />
          </a>
        </div>
      )}
    </>
  );
}

export default BackToTop;
